var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientBriefcaseX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 21C21.6569 21 23 19.6569 23 18V10C23 8.34315 21.6569 7 20 7H17V5C17 3.34315 15.6569 2 14 2H10C8.34315 2 7 3.34315 7 5V7H4C2.34315 7 1 8.34315 1 10V18C1 19.6569 2.34315 21 4 21H20ZM9 7V5C9 4.44772 9.44772 4 10 4H14C14.5523 4 15 4.44772 15 5V7H9ZM4 19C3.44772 19 3 18.5523 3 18V10C3 9.44772 3.44772 9 4 9H20C20.5523 9 21 9.44772 21 10V18C21 18.5523 20.5523 19 20 19H4Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientBriefcaseX2);
export default __webpack_public_path__ + "static/media/ClientBriefcaseX2.a762acd3db5f879e149c8561d838b947.svg";
export { ForwardRef as ReactComponent };